module.exports = __webpack_public_path__ + "img/OnArchitecture5.79a72a9b.jpg";